import httpClient from './httpClient';

const END_POINT = '/api/payment';
const addpayment = (id, nbreUser, clientId)  => httpClient.post(END_POINT, {id, nbreUser, clientId});
const sendFacture = subscription => httpClient.post('/api/sendFacture', {subscription});
const getPublicKey  = () => httpClient.get('/api/getPublicKey');
const createCustomerStripe = (id, card) => httpClient.post('/api/createCustomer', {id, card});
export {
    addpayment,
    sendFacture,
    createCustomerStripe,
    getPublicKey
};
